PT.FilterPreview = {};

(function ($) {
  $(function() {
    if (!$('#add-filter').length) { return; }

    PT.FilterPreview = {
      // stores a copy of the filter on page load
      original: "",

      regexp: function() {
        var specials = [
          '[', ']', '{', '}',
          '(', ')', '|', '-',
          '*', '.', '\\',
          '?', '+', '^', '$',
          ' ', '#',
          '\t', '\f', '\v', '\n', '\r'
        ];
        return new RegExp('(\\' + specials.join('|\\') + ')', 'g');
      }(),

      escape: function(text) {
        return text.replace(PT.FilterPreview.regexp, '\\$1');
      },

      filters: function() {
        var filter_params = [];

        $(".filter-fields tr:visible").each(function() {
          var $row = $(this);
          var filter = $row.find(".port-filter").val();
          var enabled = $row.find("input.filter-enabled").is(":checked")

          if (filter.length > 0 && enabled) {
            filter_params.push({
              filter: filter,
              is_regex: !!$row.find("input.radio:checked").data("regex")
            })
          }
        });

        return filter_params;
      },

      preview: function(isNotPageLoad) {
        var filters = this.filters();

        var preview = _.map(filters, function(filter) {
          if (filter.is_regex) {
            return filter.filter;
          } else {
            return PT.FilterPreview.escape(filter.filter)
          }
        })
        .join("|");

        if (preview.length == 0) {
          $("#live-filter-preview")
            .text("No log filters. All messages are being processed.")
            .addClass("copy emphasized");
        } else {
          $("#live-filter-preview").text(preview).removeClass("copy emphasized");
        }

        // any time we are previewing the filter, that means something has
        // changed and we need to show those changes; in light of that, we
        // can show the "Save" button at this time, for example (but only if we
        // are not experiencing the initial page load)
        //
        // instead of tying in the specifics here, we will just fire an event
        // that the filter form has been modified
        if (isNotPageLoad) {
          $(document).trigger("port:filters:modified");
        }
      }
    };

    var PortFiltersForm = {
      addFields: function(link) {
        var new_id  = new Date().getTime();
        var regexp  = /IDPLACEHOLDER/g;
        var content = $(link)
          .closest("[data-multi-model-wrapper=true]")
          .find(".new-fields")
          .html()
          .replace(regexp, new_id);

        $(link)
          .closest("[data-multi-model-wrapper=true]")
          .find(".fields")
            .append(content)
            .find(".port-filter:last")
              .focus();
      },

      removeFields: function(link) {
        $(link).closest(".form-fields").hide();
        $(link).prev("input[type=hidden]").val(1);

        PT.FilterPreview.preview(true);

        // If we're down to 0 fields shown, show a new one
        if ($(".filter-fields tr:visible").length == 0) {
          $("#add-filter").trigger("click");
        }
      }
    };

    $('#add-filter').click(function() {
      PortFiltersForm.addFields(this);
    });

    $(document).on('click', '.remove-filter', function() {
      var confirmation = $(this).data("confirm");

      if (confirmation) {
        if (confirm(confirmation)) {
          PortFiltersForm.removeFields(this);
        }
      } else {
        PortFiltersForm.removeFields(this);
      }

      return false;
    });

    $(document).on("change", "input.filter-enabled", function() {
      $(this)
        .closest("tr")
        .toggleClass("disabled", !$(this).is(":checked"));

      PT.FilterPreview.preview(true);
    });

    $(document).on("click", ".log-filters input.radio", function() {
      PT.FilterPreview.preview(true);
    });

    $(document).on("keyup", ".log-filters .port-filter", function(e) {
      PT.FilterPreview.preview(true);
    });

    // Do our first preview
    PT.FilterPreview.preview(false);
  });
})(jQuery);
